import { Trans } from '@lingui/react/macro';

import { CardHeading } from './CardHeading';
import { CloudConnectPaymentHistoryList } from './CloudConnectPaymentHistoryList';

export const CloudConnectPaymentHistoryCard = () => {
  return (
    <div className="flex flex-col gap-16 py-16">
      <CardHeading className="mb-24">
        <Trans>Invoices</Trans>
      </CardHeading>

      <CloudConnectPaymentHistoryList showSeatsColumn />
    </div>
  );
};
